<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de estorno de entradas">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/almoxarifado/relatorio-estorno-entrada/List'

export default {
    components: { List },
}
</script>